import { render } from "./Medico03.vue?vue&type=template&id=846cf568&scoped=true"
import script from "./Medico03.vue?vue&type=script&lang=js"
export * from "./Medico03.vue?vue&type=script&lang=js"

import "@/assets/css/wizardResumen.css?vue&type=style&index=0&id=846cf568&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-846cf568"]])

export default __exports__